// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class FacetsService {
   $filter: any
   appState: any
   collapsed: any
   config: any
   dateRange: any
   events: any
   i18n: any
   results: any
   scope: any
   translationService: any
   searchScopeService: SearchScopeService
   utils: any
   constructor(configService: any, results: any, appState: any, utils: any, events: any, translationService: any, $filter: any, dateRange: any, searchScopeService: SearchScopeService) {
      this.update = this.update.bind(this)
      this.facetValue = this.facetValue.bind(this)
      this.negatedFacetValue = this.negatedFacetValue.bind(this)
      this.isApplied = this.isApplied.bind(this)
      this.isNegated = this.isNegated.bind(this)
      this.clear = this.clear.bind(this)
      this.toggle = this.toggle.bind(this)
      this.getFacetClasses = this.getFacetClasses.bind(this)
      this.removeFilterByFacetName = this.removeFilterByFacetName.bind(this)
      this.remove = this.remove.bind(this)
      this.add = this.add.bind(this)
      this.createFacet = this.createFacet.bind(this)
      this.createDateRangeValue = this.createDateRangeValue.bind(this)
      this.updateAppliedState = this.updateAppliedState.bind(this)
      this.sortFacet = this.sortFacet.bind(this)
      this.sortFacetCounts = this.sortFacetCounts.bind(this)
      this.updateCollapsedState = this.updateCollapsedState.bind(this)
      this.facets = this.facets.bind(this)
      this.getActiveFilters = this.getActiveFilters.bind(this)
      this.excludedDatabases = this.excludedDatabases.bind(this)
      this.toggleCollapsed = this.toggleCollapsed.bind(this)
      this.getValueToTranslate = this.getValueToTranslate.bind(this)

      this.results = results
      this.appState = appState
      this.utils = utils
      this.events = events
      this.translationService = translationService
      this.searchScopeService = searchScopeService
      this.$filter = $filter
      this.dateRange = dateRange
      this.scope = {
         facets: [],
         applied: false,
         activeFilters: []
      }
      this.config = configService.data
      this.collapsed = {}
      this.appState.on('apply', (page: string) => {
         if(page === "1") {
            this.update()
         }
      })
      this.results.on('new', (data: any) => {
         if(data?.query?.page_number === 1) {
            this.update()
         }
      })
      this.i18n = this.translationService
   }

   update() {
      this.scope.facets          = this.facets()
      this.scope.applied         = _(this.scope.facets).any((f: any) => f.applied)
      return this.scope.activeFilters   = this.getActiveFilters()
   }

   facetValue(facet: any, value: any) {
      if(facet.name === "DatabaseName") { // fix for ticket CDI-29667
         return `${facet.name},${this.utils.summonEscapeWithParentesis(value)},f`
      } else {
         return `${facet.name},${this.utils.summonEscape(value)},f`
      }
   }

   negatedFacetValue(facet: any, value: any) {
      return `${facet.name},${this.utils.summonEscape(value)},t`
   }

   isApplied(facet: any, value: any, count: any) {
      return this.isAppliedBy(facet, value, count, this.appState.params) || this.isAppliedBy(facet, value, count, this.appState.searchScopeParams) 
   }

   isAppliedBy(facet: any, value: string, count: any, params: any) {
      if (facet.type === "daysold") {
         return _(params.rf).some((rf: any) => (rf.indexOf(facet.name) > -1) && (rf.indexOf(count.days) > -1))
      } else if (facet.type === 'daterange') { 
         return _(params.rf).some((rf: any) => rf.indexOf(facet.name) > -1)
      } else {
         return _(params.fvf).contains(this.facetValue(facet, value))
      }
   }

   isNegated(facet: any, value: any) {
      return this.isNegatedBy(facet, value, this.appState.params) || this.isNegatedBy(facet, value, this.appState.searchScopeParams) 
   }

   isNegatedBy(facet: any, value: any, params: any) {
      if ((facet.type === 'daterange') || (facet.type === 'daysold')) {
         return false
      } else {
         return _(params.fvf).contains(this.negatedFacetValue(facet, value))
      }
   }

   clear(facet: any, appliedOrNegated: any) {
      let facetAction = 'f'
      if (appliedOrNegated === 'negated') {
         facetAction = 't'
      }
      const setState = () => {
         const rx = new RegExp(`^${facet.name},.*,${facetAction}`)
         return this.appState.params.fvf = _(this.appState.params.fvf).reject((f: any) => rx.test(f))
      }
      this.appState.applyStateWithSnapShot(setState)
      return this.events.gaPush("refinements", "clear", facet.name)
   }

   toggle(facet: any, value: any, included = true) {
      const isAppliedByUser = this.isAppliedBy(facet, value, null, this.appState.params)
      const isNegatedByUser = this.isNegatedBy(facet, value, this.appState.params)
      const isAppliedByScope = this.isAppliedBy(facet, value, null, this.appState.searchScopeParams)
      const isNegatedByScope = this.isNegatedBy(facet, value, this.appState.searchScopeParams)

      if (isAppliedByScope || isNegatedByScope) {
         this.searchScopeService.clearScopeAsSideEffect() 
         return
      }

      const setState = () => {
         this.appState.params.pn = 1 // go to page 1 upon changing facet
         if ((included != null) && !((included === isAppliedByUser) || (!included === isNegatedByUser))) {
            return this.add(facet, value, included)
         } else if (isAppliedByUser || isNegatedByUser) {
            return this.remove(facet, value)
         } else {
            // default is to include the facet
            return this.add(facet, value, included)
         }
      }
      return this.appState.applyStateWithSnapShot(setState)
   }

   getFacetClasses(facet: any, count: any, opts={countOnly:true}) {
      let applied, negated
      if (opts.countOnly) {
         ({
            applied
         } = count);
         ({
            negated
         } = count)
      } else {
         ({
            applied
         } = facet);
         ({
            negated
         } = facet)
      }
   
      return {
         applied,
         negated
      }
   }

   removeFilterByFacetName(facetName: any, value: any) {
      const facet = _(this.scope.facets).find((f: any) => f.name === facetName)
      const count = facet.counts.filter((f: any) => f.value === value)[0]
      if(count?.fromSearchScope) {
         this.searchScopeService.clearScopeAsSideEffect()
      } else if (facetName === 'PublicationDate') {
         return this.dateRange.clearSelection()
      } else {
         const setState = () => {
            // go to page 1 upon changing facet
            this.appState.params.pn = 1 
            if (facetName === 'NewRecords') {
               this.appState.params.rf = _(this.appState.params.rf).reject((f: any) => f.indexOf("NewRecords") === 0)
               return this.events.gaPush('refinements', 'clear', 'NewRecords')   
            } else {
               return this.remove(facet, value)
            }
         }
         return this.appState.applyStateWithSnapShot(setState)
      }
   }

   remove(facet: any, value: any, opts = {quiet:false}) {
      const v = this.facetValue(facet, value)
      const n = this.negatedFacetValue(facet, value)
      this.appState.params.fvf = _(this.appState.params.fvf).reject((f: any) => (f === v) || (f === n))
      if (!opts.quiet) {
         this.events.gaPush("refinements", "remove", `${facet.name}:${value}`)
         return this.events.publish("actions", "filters:remove", {
            facet,
            value
         }
         )
      }
   }

   add(facet: any, value: any, included = true) {
      this.remove(facet, value, {quiet:true})
      this.appState.params.fvf.push( included ? this.facetValue(facet, value) : this.negatedFacetValue(facet, value) )
      this.events.gaPush("refinements", "add", `${facet.name}:${value}`)
      return this.events.publish("actions", "filters:add", {
         facet,
         value
      }
      )
   }

   createFacet(props: any) {
      const facet = _.clone(props)
      const data = facet.type === 'daterange' ?
         this.results.data.search.publication_date_facet
         : facet.type === 'daysold' ?
            this.results.data.search.new_records_facet
            :
            _(this.results.data.search.facet_fields || []).find((f: any) => f.display_name === facet.name)

      if (data && (data.counts != null)) {
         this.updateValues(facet, data)
         this.updateAppliedState(facet)
         this.updateCollapsedState(facet)
      
         // we don't want to display the daterange or daysold if there is no data to render, except when it's applied
         if ((facet.type === 'daterange') || (facet.type === 'daysold')) {
            const reduceFn = (memo: any, value: any) => memo + value.count
            facet.visible = facet.applied || ((_(facet.counts).reduce(reduceFn, 0)) > 1)
         }
      }

      if (data) { return facet } else { return null }
   }

   createDateRangeValue() {
      const preset = this.dateRange.selection.selectedYears
      if (preset) { return this.i18n.translations['DATE_PRESET_' + preset + 'Y'] } else { return this.i18n.translations.CUSTOM_DATES }
   }

   updateValues(facet: any, data: any) {
      let facetDateValue: any
      facet.showmore = data.has_more_facets
      facet.fieldName = data.field_name
      if (facet.type === 'daterange') { facetDateValue = this.createDateRangeValue() }
      const {
         i18n
      } = this
      return facet.counts = _(data.counts).map((f: any) => ({
         value: facet.type === 'daysold' ? i18n.translate(i18n.translations.LAST_X_DAYS, {x: f.days}) : facet.type === 'daterange' ? facetDateValue : f.value,

         // for publicationdate
         year:  f.year,

         count: f.count,
         days: f.days
      })) // for newrecords
   }

   /**
    * Handle cases in which original value is not translatable 
    * (the original value is not a part of the translation keys)
    */
   getValueToTranslate(name: string, value: string){
      //for Secondary Type facet (i.e. retracted_publication -> Retracted Publication)
      if (name === 'SecondaryResourceType'){
         return SECONDARY_TYPE_VALUES.get(value)
      }
      return value
   }

   updateAppliedState(facet: any) {
      facet.applied = false
      facet.counts.forEach((count: any) => {
         count.applied = this.isApplied(facet, count.value, count)
         count.negated = this.isNegated(facet, count.value)
         count.translation = this.i18n.translate(this.getValueToTranslate(facet.name, count.value)) // Enhancement being applied to more facets also
         // used for sorting
         count.selected = count.applied || count.negated
         count.fromSearchScope = this.isAppliedBy(facet, count.value, count, this.appState.searchScopeParams) 
            || this.isNegatedBy(facet, count.value, this.appState.searchScopeParams)
         facet.applied = facet.applied || count.applied || count.negated
      })
      const negated = _(facet.counts).filter((f: any) => f.negated)
      facet.negatedCount = negated.length ? negated.length : ''
      const applied = _(facet.counts).filter((f: any) => f.applied)
      facet.appliedCount = applied.length ? applied.length : ''
      return this.sortFacetCounts(facet)
   }

   sortFacet(facet: any, method: any) { 
      facet.sortMethod = method
      return this.sortFacetCounts(facet)
   }

   sortFacetCounts(facet: any) {
      if (!facet || !facet.counts) { return }
      return facet.counts = (() => { switch (facet.sortMethod) {
         case '-count': return this.$filter('orderBy')(facet.counts, "-count")
         case 'value': return this.$filter('localeSort')(facet.counts, 'value')
         case 'selected': return this.$filter('orderBy')(facet.counts, '-selected')
         case 'negated': return this.$filter('orderBy')(facet.counts, '-negated')
         case 'applied': return this.$filter('orderBy')(facet.counts, '-applied')
         default: return facet.counts
      } })()
   }

   updateCollapsedState(facet: any) {
      if (facet.name in this.collapsed) { facet.collapsed = this.collapsed[facet.name] }
      if (facet.applied) { return facet.collapsed = false }
   }

   facets() {
      const data = _(this.config.facets || [])
         .map((f: any) => {
            return this.createFacet(f)
         })
      return _(data).compact()
   }

   getActiveFilters() {
      const activeFilters: any = []
      _(this.scope.facets).forEach(function(facet: any) { 
         if (facet.applied) {
            return _(facet.counts).forEach(function(f: any) { 
               if (f.applied || f.negated) {
                  f.facetGroup = facet.name
                  return activeFilters.push(f)
               }
            })
         }
      })
      return activeFilters.concat(this.excludedDatabases(activeFilters))
   }

   // negated databases are not returned in results.data.search.facet_fields from search request, so we build dummy facet from params
   // shown in clearRefinementsContainer 
   excludedDatabases(activeFilters: any) {
      const {
         utils
      } = this
      const excludedDatabases: any = []
      _(_(this.appState.params.fvf).filter((f: any) => f.indexOf("DatabaseName") === 0)).forEach(function(paramString: any) {
         const value = `${utils.summonUnEscape(paramString.split(',')[1])}`
         // push excluded database only if it's not included in active filters to avoid duplication
         if (!(_(activeFilters).some((a: any) => a.value === value))) {
            return excludedDatabases.push({
               value,
               name: 'DatabaseName',
               facetGroup: 'DatabaseName',
               negated: true
            })
         }
      })
      return excludedDatabases  
   }


   toggleCollapsed(facet: any) {
      if (facet.applied) {
         facet.collapsed = false
      } else {
         facet.collapsed = !facet.collapsed
      }
      return this.collapsed[facet.name] = facet.collapsed
   }
}

//Convert Secondary Type to translatable values
const SECONDARY_TYPE_VALUES = new Map<string, string>([
   ['retracted_publication', 'Retracted Publication'],
   ['retraction_notice', 'Retraction Notice'],
   ['review_article', 'Review Article'],
   ['preprint', 'Preprint'],
   ['publication_addendum', 'Publication with Addendum'],
   ['publication_corrigendum', 'Publication with Corrigendum'],
   ['withdrawn_publication', 'Withdrawn Publication'],
   ['withdrawal_notice', 'Withdrawal Notice'],
   ['publication_exp_concern', 'Publication with Expression of Concern'],
   ['primary_source', 'Primary Source'],
   ['online_first', 'Online First Article'],
   ['open_educational_resource', 'Open Educational Resource'],
])
 

FacetsService.$inject = ['configService', 'dataService', 'appStateService', 'utilitiesService', 'eventService', 'translationService', '$filter', 'dateRangeService', 'searchScopeService']

angular.module('summonApp.services')
   .service('facetsService', FacetsService)
